import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-page-container">
            {/* Header Banner */}
            <div className="privacy-header-banner">
                <div className="privacy-banner-overlay"></div>
                <div className="privacy-banner-content">
                    <h1 className="privacy-main-title">Privacy Policy</h1>
                    <p className="privacy-sub-title">Iconic Greenland Limited</p>
                    <div className="privacy-effective-date">
                        Effective Date: 07 July 2026
                    </div>
                </div>
            </div>

            {/* Main Content Container */}
            <div className="privacy-simple-wrapper">
                <div className="privacy-simple-container">

                    <h1 className="privacy-main-heading">Privacy Policy</h1>

                    <p className="privacy-paragraph">
                        Iconic Greenland respects your privacy and is committed to protecting the personal information you provide to us. This Privacy Policy explains how we collect, use, store, and protect your information when you interact with our website, Facebook Page, advertisements, lead generation forms, and other digital platforms.
                    </p>

                    <h2 className="privacy-sub-heading">Information Collection and Use</h2>
                    <p className="privacy-paragraph">
                        When you submit an inquiry or lead generation form, we may collect certain personally identifiable information, such as your name, email address, phone number, and postal address. This information is collected to help us contact or identify you, assist with property inquiries, facilitate transactions, and provide updates on new listings or services relevant to your interests.
                    </p>
                    <ul className="privacy-simple-list">
                        <li>Full Name, Phone Number, and Email Address</li>
                        <li>Current Address or Location</li>
                        <li>Preferred Property Type, Flat Size, and Location</li>
                        <li>Property Budget Range and Purchase Timeline</li>
                    </ul>

                    <h2 className="privacy-sub-heading">How We Collect Your Information</h2>
                    <p className="privacy-paragraph">
                        We collect personal information through various digital channels including Facebook and Instagram Lead Forms, our official website, landing pages, direct phone calls, WhatsApp messaging, and marketing campaigns.
                    </p>

                    <h2 className="privacy-sub-heading">Use of Information</h2>
                    <p className="privacy-paragraph">
                        Iconic Greenland uses the information collected to contact you regarding property inquiries, provide details about available apartments, schedule project visits, and improve our customer service. We may also send relevant promotional offers and updates as permitted by law.
                    </p>

                    <h2 className="privacy-sub-heading">Sharing of Personal Information</h2>
                    <p className="privacy-paragraph">
                        Iconic Greenland does not sell or rent your personal information to third parties. We may share necessary information only with authorized employees, sales representatives, or service providers required to process your inquiry or comply with applicable laws.
                    </p>

                    <h2 className="privacy-sub-heading">Data Protection and Security</h2>
                    <p className="privacy-paragraph">
                        We take reasonable technical and organizational measures to protect your personal information from unauthorized access or misuse. However, no internet-based data transmission can be guaranteed to be completely secure.
                    </p>

                    <h2 className="privacy-sub-heading">Cookies and Digital Technologies</h2>
                    <p className="privacy-paragraph">
                        Our website may use cookies and similar technologies to understand visitor behavior and optimize marketing campaigns. Cookies act as anonymous unique identifiers sent to your browser and stored on your device's hard drive. You can choose to decline cookies in your browser settings.
                    </p>

                    <h2 className="privacy-sub-heading">Your Rights and Choices</h2>
                    <p className="privacy-paragraph">
                        You may contact Iconic Greenland at any time to request access to your personal information, correction of inaccurate data, or deletion of your information from our records.
                    </p>

                    <h2 className="privacy-sub-heading">Contact Us</h2>
                    <p className="privacy-paragraph">
                        If you have any questions regarding this Privacy Policy, please reach out to us:
                    </p>
                    <div className="contactBox">
                        <strong style={{ color: '#BD06D3', fontSize: '1.05rem', display: 'block', marginBottom: '6px' }}>
                            Iconic Greenland Limited
                        </strong>
                        Suite: 8/A&B, LilyPond Center, 3, R. K Mission Road, Motijheel, Dhaka-1000<br />
                        Phone: +880 1937-900900<br />
                        Email: <a href="mailto:info@iconicgreenland.com" className="link">info@iconicgreenland.com</a><br />
                        Website: <a href="https://iconicgreenland.com" target="_blank" rel="noreferrer" className="link">www.iconicgreenland.com</a>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;